import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CatalogoRequest } from 'src/app/modal/catalogo/catalogo-request';
import { CatalogoResponse } from 'src/app/modal/catalogo/catalogo-response';
import { CatalogoSourvenirResponse } from 'src/app/modal/catalogo/catalogo-sourvenir-response';
import { Generalsearchrequest } from 'src/app/modal/catalogo/generalsearchrequest';
import { ResponseComun } from 'src/app/modal/catalogo/response-comun';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { HostListener } from '@angular/core';
import {
  filter,
  debounceTime,
  map,
  distinctUntilChanged,
  takeUntil,
} from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SeoService, SeoSnapshot } from '../../../service/seo/seo.service';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';
import { RateLimitService } from '../../../shared/services/rate-limit.service';

// nlpr
@Component({
  selector: 'app-portada-panel',
  templateUrl: './portada-panel.component.html',
  styleUrls: ['./portada-panel.component.scss'],
  providers: [DatePipe],
})
export class PortadaPanelComponent implements OnInit, OnDestroy {
  tagChoosen: string = '';
  idCategoria: string = '0';
  idSubCategoria: string = '0';
  listProductos: CatalogoResponse = new CatalogoResponse();
  rangoInicio = 0;
  rangoFin = 4;
  titulo: string;
  busqueda: string;
  subBusqueda: string;
  fMerchadising: boolean = false;
  fSubCategoria: boolean = false;
  listMerchadising: CatalogoSourvenirResponse;
  listCategoria: ResponseComun;
  listSubCategoria: ResponseComun = new ResponseComun();
  paginaActual: number = 1;
  generalsearchrequest: Generalsearchrequest;
  Arr = Array;
  totalPaginas: number;
  totalPaginasArray: any;
  totalPaginasArrayTemp: any;
  LCategoria: any;
  LSubCategoria: any;
  busquedasGeneral = false;
  busquedaPublicaciones = false;
  busquedaMerchadising = false;
  fResultados = false;
  fResultados1 = false;
  isLoading = false;
  //tmpIdCategoria:any;
  //tmpIdSubCategoria:any;

  // nlpr ini
  columnas = [[], [], []];
  columnas1 = [[], []];
  columnas2: any[];
  showIpad = false;
  // nlpr fin

  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  private imageUrlCache: Map<string, string | null> = new Map();
  private imageLoadStartTimes: Map<string, number> = new Map();
  private imageReadyForDisplay: Map<string, boolean> = new Map();
  public isSkeletonVisible: Map<string, boolean> = new Map();

  filtroBusquedaGeneral: string;

  lblTextoBusqueda: string = '';
  lblFecIni: string = '';
  lblFecFin: string = '';
  private requestId = 0;
  private destroy$ = new Subject<void>();

  // Variable para mantener el ordenamiento actual
  currentSortValue: string = '';

  // Slug → id (categoría y subcategoría)
  private CAT_SLUG_TO_ID: Record<string, string> = {
    fotografias: '1',
    portadas: '2',
    consultas: '3',
  };
  private SUB_SLUG_TO_ID: Record<string, Record<string, string>> = {
    '1': {
      // FOTOGRAFÍAS
      cultura: '1',
      politica: '2',
      deportes: '3',
      espectaculos: '4',
      regiones: '11',
      economia: '12',
      sociedad: '13',
      presidentes: '14',
    },
    '2': {
      // PORTADAS
      'siglo-xix': '5',
      'siglo-xx': '6',
      'siglo-xxi': '7',
    },
    '3': {
      // CONSULTAS (si las hubiera)
    },
  };

  // Mapeos inversos: ID → slug (para generar URLs amigables)
  private CAT_ID_TO_SLUG: Record<string, string> = {
    '1': 'fotografias',
    '2': 'portadas',
    '3': 'consultas',
  };
  private SUB_ID_TO_SLUG: Record<string, Record<string, string>> = {
    '1': {
      // FOTOGRAFÍAS
      '1': 'cultura',
      '2': 'politica',
      '3': 'deportes',
      '4': 'espectaculos',
      '11': 'regiones',
      '12': 'economia',
      '13': 'sociedad',
      '14': 'presidentes',
    },
    '2': {
      // PORTADAS
      '5': 'siglo-xix',
      '6': 'siglo-xx',
      '7': 'siglo-xxi',
    },
    '3': {
      // CONSULTAS (si las hubiera)
    },
  };

  private prevSeo!: SeoSnapshot;

  rateLimitActive = false;
  private rateLimitSubscription: any;

  constructor(
    private route: ActivatedRoute,
    private novedadesService: NovedadesService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private renderer: Renderer2,
    private el: ElementRef,
    private seo: SeoService,
    private datePipe: DatePipe,
    private protectedImageService: ProtectedImageService,
    private rateLimitService: RateLimitService,
    private cdr: ChangeDetectorRef
  ) {
    // Limpiar cache al inicializar
    this.clearProtectedImagesCache();
  }

  detalleComponente(idSeleccionado, titleShowUrl) {
    // console.log('idSeleccionado:' + idSeleccionado);
    this.utilitarioService.idSeleccionado = idSeleccionado;
    this.router.navigate(['/dtp/' + titleShowUrl]);
  }

  /**
   * Se obtiene el listado de categorias para sacar la descripción y el titulo
   */
  obtenerCategorias() {
    const timestamp = new Date().toLocaleTimeString('es-PE', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    // ✅ VALIDACIÓN: Solo ejecutar si estamos en portadas
    if (this.novedadesService.idCategoria !== '2') {
      //console.log(`⏭️ [PORTADAS] [${timestamp}] obtenerCategorias cancelado - no estamos en portadas. idCategoria: ${this.novedadesService.idCategoria}`);
      return;
    }

    //console.log(`📋 [PORTADAS] [${timestamp}] obtenerCategorias - Iniciando (Página: ${this.paginaActual})`);

    // Iniciar loading al comenzar la carga de categorías
    this.isLoading = true;
    this.fResultados = false;
    this.fResultados1 = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    this.listCategoria = new ResponseComun();
    this.novedadesService.obtenerCategoria().subscribe(
      (data) => {
        const timestampData = new Date().toLocaleTimeString('es-PE', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });

        // ✅ VALIDACIÓN EN CALLBACK: Verificar que aún estamos en portadas
        if (this.novedadesService.idCategoria !== '2') {
          //console.log(`⏭️ [PORTADAS] [${timestampData}] obtenerCategorias CALLBACK cancelado - ya no estamos en portadas. idCategoria: ${this.novedadesService.idCategoria}`);
          return;
        }

        this.listCategoria = data;
        // Con las categorias cargadas obtenemos combo de subcategorias
        //console.log(`📋 [PORTADAS] [${timestampData}] obtenerCategorias - idCategoria: ${this.novedadesService.idCategoria}`);
        if (
          this.novedadesService.idCategoria != null &&
          this.novedadesService.idCategoria > 0
        ) {
          //console.log(`📋 [PORTADAS] [${timestampData}] obtenerCategorias - Llamando obtenerSubcategoriaXCategoria con ID: ${this.novedadesService.idCategoria}`);
          this.obtenerSubcategoriaXCategoria(this.novedadesService.idCategoria);
        } else {
          //console.log(`📋 [PORTADAS] [${timestampData}] obtenerCategorias - Llamando cambiarCategoria con PORTADAS_HISTORICAS`);
          this.cambiarCategoria('PORTADAS_HISTORICAS');
        }
      },
      (error) => {
        const timestampError = new Date().toLocaleTimeString('es-PE', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        //console.error(`❌ [PORTADAS] [${timestampError}] Error en obtenerCategorias:`, error);
      }
    );
  }

  obtenerCategoriasBasico() {
    // Iniciar loading al comenzar la carga de categorías básicas
    this.isLoading = true;
    this.fResultados = false;
    this.fResultados1 = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    // console.log('obtenerCategoriasBasico');
    this.listCategoria = new ResponseComun();
    this.novedadesService.obtenerCategoria().subscribe((data) => {
      this.listCategoria = data;
      // console.log(this.listCategoria);

      if (
        this.novedadesService.idCategoria != null &&
        this.novedadesService.idCategoria > 0
      ) {
        // console.log('1');
      } else {
        // console.log('2');
        this.cambiarCategoriaBasico('PORTADAS_HISTORICAS');
      }

      // Búsqueda general
      this.busquedaGeneral();
    });
  }

  obtenerCategoriasBasico2() {
    // Iniciar loading al comenzar la carga de categorías básicas 2
    this.isLoading = true;
    this.fResultados = false;
    this.fResultados1 = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    // console.log('obtenerCategoriasBasico2');
    this.listCategoria = new ResponseComun();
    this.novedadesService.obtenerCategoria().subscribe((data) => {
      this.listCategoria = data;
      // console.log(this.listCategoria);
      if (
        this.novedadesService.idCategoria != null &&
        this.novedadesService.idCategoria > 0
      ) {
        // console.log('1');
      } else {
        // console.log('2');
        this.cambiarCategoriaBasico('PORTADAS_HISTORICAS');
      }
      this.busquedaGeneralXTag();
    });
  }
  obtenerSubcategoriaXCategoria(id) {
    // console.log(
      // 'obtenerSubcategoriaXCategoria - ID:',
      // id,
      // 'Página actual:',
      // this.paginaActual
    // );

    // ✅ VALIDACIÓN: Si no hay ID de categoría válido, no continuar
    if (!id || id === '' || id === '0') {
      console.warn(
        '⚠️ obtenerSubcategoriaXCategoria cancelado - ID de categoría inválido:',
        id
      );
      return;
    }

    // ✅ VALIDACIÓN: Verificar que el servicio tenga un ID de categoría válido
    if (
      !this.novedadesService.idCategoria ||
      this.novedadesService.idCategoria === '' ||
      this.novedadesService.idCategoria === '0'
    ) {
      console.warn(
        '⚠️ obtenerSubcategoriaXCategoria cancelado - novedadesService.idCategoria inválido:',
        this.novedadesService.idCategoria
      );
      return;
    }

    // Validación defensiva: verificar que listCategoria esté disponible
    if (
      !this.listCategoria?.response?.list ||
      !this.listCategoria.response.list.length
    ) {
      console.warn(
        '⚠️ listCategoria no está disponible, obteniendo categorías primero'
      );
      this.obtenerCategorias();
      return;
    }

    this.novedadesService.obtenerSubCategoria(id).subscribe((data) => {
      this.listSubCategoria = data;

      // 🔍 LOG TEMPORAL: Ver qué subcategorías vienen del backend
      // console.log(
        // '🔍 [DEBUG PORTADAS] listSubCategoria recibida del backend:',
        // this.listSubCategoria
      // );
      // console.log(
        // '🔍 [DEBUG PORTADAS] Subcategorías disponibles:',
        // this.listSubCategoria?.response?.list?.map((item) => ({
          // id: item.id,
          // name: item.name,
        // }))
      // );

      if (this.listSubCategoria.response.list.length > 0) {
        this.fSubCategoria = true;
      }

      // Buscar publicaciones con validaciones defensivas
      //this.busqueda = this.listCategoria.response.list.find(data=>data.id==this.tmpIdCategoria).name;
      const categoriaEncontrada = this.listCategoria?.response?.list?.find(
        (data) => data.id == this.novedadesService.idCategoria
      );
      this.busqueda = categoriaEncontrada?.name || '';
      this.titulo = this.busqueda ? this.busqueda.toLowerCase() : '';
      // console.log('this.titulo:' + this.titulo);
      //console.log("tmpIdSubCategoria",this.tmpIdSubCategoria);
      this.LCategoria = this.busqueda;
      //if(this.tmpIdSubCategoria!=null && this.tmpIdSubCategoria!=""){
      if (
        this.novedadesService.idSubCategoria != null &&
        this.novedadesService.idSubCategoria != ''
      ) {
        //this.subBusqueda = this.listSubCategoria.response.list.find(data=>data.id==this.tmpIdSubCategoria).name;
        const subCategoriaEncontrada =
          this.listSubCategoria?.response?.list?.find(
            (data) => data.id == this.novedadesService.idSubCategoria
          );
        this.subBusqueda = subCategoriaEncontrada?.name || '';

        // 🔍 LOG DE DEBUG: Ver tipo de datos ANTES de asignar
        // console.log('🔍 [DEBUG CRÍTICO PORTADAS] ANTES de asignar LSubCategoria:');
        // console.log('  - novedadesService.idSubCategoria:', this.novedadesService.idSubCategoria, 'Tipo:', typeof this.novedadesService.idSubCategoria);
        // console.log('  - subCategoriaEncontrada?.id:', subCategoriaEncontrada?.id, 'Tipo:', typeof subCategoriaEncontrada?.id);
        // console.log('  - LSubCategoria actual:', this.LSubCategoria, 'Tipo:', typeof this.LSubCategoria);

        // ✅ Asegurar que sea string explícitamente
        this.LSubCategoria = String(this.novedadesService.idSubCategoria);

        //console.log('✅ [PORTADAS] DESPUÉS de asignar LSubCategoria:', this.LSubCategoria, 'Tipo:', typeof this.LSubCategoria);
        //console.log('🔍 [DEBUG PORTADAS] subCategoriaEncontrada:', subCategoriaEncontrada);
        //console.log('🔍 [DEBUG PORTADAS] novedadesService.idSubCategoria:', this.novedadesService.idSubCategoria);
      } else {
        // ✅ Cuando no hay subcategoría seleccionada, mostrar TODOS
        this.subBusqueda = '';
        this.LSubCategoria = ''; // Valor vacío para TODOS
        //console.log('✅ [PORTADAS] LSubCategoria vacío (TODOS)');
        //console.log('🔍 [DEBUG PORTADAS] Buscando elemento TODOS en la lista...');
        const elementoTodos = this.listSubCategoria?.response?.list?.find(
          (data) =>
            data.id === '' ||
            data.id === '0' ||
            data.name?.toUpperCase() === 'TODOS' ||
            (data as any).descript?.toUpperCase() === 'TODOS'
        );
        //console.log('🔍 [DEBUG PORTADAS] Elemento TODOS encontrado:', elementoTodos);
      }

      // 🔄 Forzar detección de cambios INMEDIATAMENTE para que ngFor renderice las opciones
      this.cdr.detectChanges();

      // 🔄 Luego, en el siguiente tick, asignar el valor y forzar otra detección
      setTimeout(() => {
        // Reasignar el valor para forzar que ngModel se actualice después de que las opciones estén renderizadas
        const valorActual = this.LSubCategoria;
        this.LSubCategoria = '';
        this.cdr.detectChanges();

        setTimeout(() => {
          this.LSubCategoria = valorActual;
          this.cdr.detectChanges();
          //console.log('🔄 [PORTADAS] detectChanges ejecutado para LSubCategoria:', this.LSubCategoria);

          const dropdown = document.querySelector(
            '.btnSubtipo'
          ) as HTMLSelectElement;
          // console.log('🔄 [PORTADAS] Verificando dropdown en DOM - value:', dropdown?.value);
          //console.log('🔄 [PORTADAS] Verificando dropdown en DOM - opciones:', Array.from(dropdown?.options || []).map(o => ({value: o.value, text: o.text, selected: o.selected})));
        }, 50);
      }, 100);

      // ✅ SIEMPRE notificar al header después de establecer la subcategoría (por defecto o desde URL)
      if (this.novedadesService.idSubCategoria) {
        // console.log('🔄 [PORTADAS] Notificando al header subcategoría activa:', {categoria: this.novedadesService.idCategoria,subcategoria: this.novedadesService.idSubCategoria,nombre: this.LSubCategoria});

        // Buscar el componente header y activar la subcategoría
        setTimeout(() => {
          const headerElement = document.querySelector('app-header');
          if (headerElement && (headerElement as any).__ngContext__) {
            const headerComponent = (headerElement as any).__ngContext__[8];
            if (
              headerComponent &&
              typeof headerComponent.setActiveHeaderCategory === 'function'
            ) {
              headerComponent.setActiveHeaderCategory(
                this.novedadesService.idCategoria,
                this.novedadesService.idSubCategoria
              );
            }
          }
        }, 100);
      }

      this.buscarPublicaciones();
    });
  }
  cambiarCategoria(id) {
    // Si no se llamó desde obtenerCategorias, limpiar datos inmediatamente
    if (!this.isLoading) {
      this.isLoading = true;
      this.fResultados = false;
      this.fResultados1 = false;
      this.listProductos = new CatalogoResponse();
      this.columnas = [[], [], []];
      this.columnas1 = [[], []];
      this.columnas2 = [];
      this.clearProtectedImagesCache();
    }

    this.busqueda = id;
    // console.log('cambiarCategoriaXX:', id);
    this.titulo = this.busqueda.toLowerCase();
    // console.log('xxxxxxxxxxxxxxxxxxxxxx' + this.utilitarioService.idCategoria);
    switch (this.utilitarioService.idCategoria) {
      case '1':
        this.titulo = 'Fotografías';
        break;
      case '2':
        this.titulo = 'PORTADAS_HISTORICAS';
        break;
      case '3':
        this.titulo = 'HEMEROTECA_DIGITAL';
        break;
    }
    // console.log('this.tituloXXXXXXXXXXXXXXXXXXXXXXX2:' + this.titulo);
    this.subBusqueda = 'Todos';
    this.LCategoria = this.busqueda;
    this.LSubCategoria = this.subBusqueda;

    // Solo resetear página a 1 si no hay parámetro page en la URL
    const currentUrl = this.router.url;
    if (!currentUrl.includes('page=')) {
      this.paginaActual = 1;
    }

    this.buscarPublicaciones();
    this.obtenerSubcategoriaBasico(
      this.listCategoria.response.list.find((data) => data.name == id).id
    );
  }

  cambiarCategoriaBasico(id) {
    // Si no se llamó desde obtenerCategoriasBasico, limpiar datos inmediatamente
    if (!this.isLoading) {
      this.isLoading = true;
      this.fResultados = false;
      this.fResultados1 = false;
      this.listProductos = new CatalogoResponse();
      this.columnas = [[], [], []];
      this.columnas1 = [[], []];
      this.columnas2 = [];
      this.clearProtectedImagesCache();
    }

    this.busqueda = id;
    // console.log('cambiarCategoria:', id);
    switch (this.utilitarioService.idCategoria) {
      case '1':
        this.titulo = 'Fotografías';
        break;
      case '2':
        this.titulo = 'PORTADAS HISTORICAS';
        break;
      case '3':
        this.titulo = 'MERCHANDISING';
        break;
    }
    //this.titulo = this.busqueda.toUpperCase();
    // console.log('this.tituloXXXXXXXXXXXXXXXXXXXXXXX2:' + this.titulo);
    this.subBusqueda = 'Todos';
    //this.fSubCategoria = true;
    this.LCategoria = this.busqueda;
    this.LSubCategoria = this.subBusqueda;

    // Solo resetear página a 1 si no hay parámetro page en la URL
    const currentUrl = this.router.url;
    if (!currentUrl.includes('page=')) {
      this.paginaActual = 1;
    }

    //this.buscarPublicaciones();
    this.obtenerSubcategoriaBasico(
      this.listCategoria.response.list.find((data) => data.name == id).id
    );
  }

  obtenerSubcategoriaBasico(id) {
    // console.log('id', id);
    this.novedadesService.obtenerSubCategoria(id).subscribe((data) => {
      this.listSubCategoria = data;
      if (this.listSubCategoria.response.list.length > 0) {
        this.fSubCategoria = true;
      }
      this.subBusqueda = this.listSubCategoria.response.list[0].name;
    });
  }

  cambiarSubCategoria(idSubCategoria) {
    // Activar loading premium inmediatamente
    this.utilitarioService.loading = true;

    // Limpiar datos inmediatamente al cambiar subcategoría
    this.isLoading = true;
    this.fResultados = false;
    this.fResultados1 = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    // Si idSubCategoria es vacío o "TODOS", navegar a la categoría principal
    if (!idSubCategoria || idSubCategoria === '') {
      this.subBusqueda = '';
      this.novedadesService.idSubCategoria = '';
      this.LSubCategoria = ''; // Mantener "TODOS" seleccionado

      // Solo resetear página a 1 si no hay parámetro page en la URL
      const currentUrl = this.router.url;
      if (!currentUrl.includes('page=')) {
        this.paginaActual = 1;
      }

      // Navegar a /portadas sin subcategoría
      this.router.navigate(['/portadas']);
      // console.log('cambiarSubCategoria - Navegando a TODOS (sin subcategoría)');
      return;
    }

    // Buscar el nombre de la subcategoría a partir del ID
    const subCategoriaEncontrada = this.listSubCategoria?.response?.list?.find(
      (item) => item.id == idSubCategoria
    );
    this.subBusqueda = subCategoriaEncontrada?.name || '';
    this.LSubCategoria = idSubCategoria; // Mantener el ID seleccionado en el dropdown

    // ✅ Actualizar novedadesService ANTES de navegar para que persista después de la navegación
    this.novedadesService.idSubCategoria = idSubCategoria;

    // Solo resetear página a 1 si no hay parámetro page en la URL
    const currentUrl = this.router.url;
    if (!currentUrl.includes('page=')) {
      this.paginaActual = 1;
    }

    // 🔗 Navegar usando URL amigable
    this.navigateToSubcategory(idSubCategoria);
    // console.log(
      // 'cambiarSubCategoria - Navegando a subcategoría con ID:',
      // idSubCategoria,
      // 'Nombre:',
      // this.subBusqueda
    // );
  }

  buscarPublicaciones() {
    const myId = ++this.requestId;

    // Asegurar que el mensaje "No results" esté oculto al iniciar búsqueda
    this.fResultados = false;
    this.fResultados1 = false;
    this.isLoading = true;
    this.utilitarioService.loading = true;

    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];

    // console.log('buscarPublicaciones');
    // console.log('LCate', this.LCategoria);
    // console.log('LSubCate', this.LSubCategoria);
    // console.log(
      // '📄 [PORTADAS] buscarPublicaciones - Página actual:',
      // this.paginaActual
    // );
    let catalogoRequest: CatalogoRequest;
    catalogoRequest = new CatalogoRequest();
    this.listProductos = new CatalogoResponse();
    catalogoRequest.authorId = '0';
    catalogoRequest.categoryId = '0';
    catalogoRequest.categoryName = this.busqueda;
    catalogoRequest.page = this.paginaActual.toString();
    catalogoRequest.subCategoryId = '0';
    catalogoRequest.subCategoryName = this.subBusqueda;
    catalogoRequest.publicationId = '0';
    catalogoRequest.size = '12';
    catalogoRequest.title = '';
    catalogoRequest.yearId = '0';
    // console.log(
      // '📄 [PORTADAS] catalogoRequest con página:',
      // catalogoRequest.page
    // );
    // console.log('catalogoRequest', catalogoRequest);
    if (this.LCategoria == 'HEMEROTECA_DIGITAL') {
      this.fSubCategoria = false;
    }
    this.novedadesService.buscarCatalogo(catalogoRequest).subscribe({
      next: (data) => {
        if (myId !== this.requestId) return;
        if (data.response.codeResponse == '0000') {
          this.listProductos = data;
          this.totalPaginas = Number(
            this.listProductos.response.nroTotalPaginas
          );
          this.totalPaginasArray = Array.from(
            Array(Number(this.listProductos.response.nroTotalPaginas)).keys()
          );

          this.busquedasGeneral = false;
          this.busquedaPublicaciones = true;
          this.busquedaMerchadising = false;
          // Actualizar rangos de paginación ahora que conocemos el total de páginas
          this.actualizarRangosPaginacion();

          this.totalPaginasArrayTemp = this.filterRange(
            this.totalPaginasArray,
            this.rangoInicio,
            this.rangoFin
          );
          // this.novedadesService.idCategoria="";
          // this.novedadesService.idSubCategoria="";
          // this.utilitarioService.busqueda="";
          this.fResultados = true;
          this.fResultados1 = false;
          this.isLoading = false;
          this.utilitarioService.loading = false;

          // Cargar tokens para las imágenes de la página actual
          this.loadTokensForCurrentPage();

          // nlpr ini
          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 3; // Determina en qué columna irá el elemento
            this.columnas[columnaIndex].push(fila);
            // Cargar imagen protegida para cada elemento
            this.loadProtectedThumbnail(fila.activoId);
          });
          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 2; // Determina en qué columna irá el elemento
            this.columnas1[columnaIndex].push(fila);
          });
          /*
        if (window.innerWidth === 1024 && window.innerHeight===768){
          // console.log("pantalla:menor");
          this.columnas2=this.columnas1;
        }else if (window.innerWidth === 1180 && window.innerHeight===820){
          // console.log("pantalla:menor");
          this.columnas2=this.columnas1;
        
        }else{
          this.columnas2=this.columnas;
          // console.log("pantalla:mayor");
        }*/
          if (this.isIPad()) {
            // console.log('xxxxxsiIpad');
            this.columnas2 = this.columnas1;
            // console.log(
              // 'xxxIpadColumnas:' +
                // this.columnas1.length +
                // '--Filas:' +
                // this.columnas1[0].length
            // );
            this.showIpad = true;
          } else {
            this.columnas2 = this.columnas;
            // console.log('xxxxxnoIpad');
            // console.log(
              // 'xxxNoIpadColumnas:' +
                // this.columnas.length +
                // '--Filas:' +
                // this.columnas[0].length
            // );
            this.showIpad = false;
          }
          const numeroDeFilas = this.columnas2.length; // 3
          const numeroDeColumnas = this.columnas2[0].length; // 3
          // console.log(
            // 'xxxcolumnas' + numeroDeFilas + '--filas:' + numeroDeColumnas
          // );

          // Aplicar ordenamiento si hay uno seleccionado
          if (this.currentSortValue) {
            this.applySortToResults(this.currentSortValue);
          }

          // nlpr fin
        } else {
          this.fResultados = false;
          this.fResultados1 = true;
          this.isLoading = false;
          this.utilitarioService.loading = false;
          this.novedadesService.idCategoria = '';
          this.novedadesService.idSubCategoria = '';
          this.utilitarioService.busqueda = '';
        }
        this.utilitarioService.loading = false;
      },
      error: (error) => {
        if (error.status === 429) {
          // Extraer información detallada del error
          const errorBody = error.error;
          const retrySeconds = errorBody?.retryAfterSeconds || 8;
          const esHome =
            this.router.url === '/' || this.router.url === '/inicio';

          // console.log('⏱️ Rate limit detectado en header:', {
            // retryAfterSeconds: retrySeconds,
            // ip: errorBody?.ip,
            // path: errorBody?.path,
            // penaltyLevel: errorBody?.penaltyLevel,
            // esHome: esHome,
          // });
          this.isLoading = false;
          this.utilitarioService.loading = false;
          // Activar el rate limiting usando el servicio centralizado
          this.rateLimitService.activateRateLimit(retrySeconds, esHome);
        } else {
          console.error('❌ Error en buscarPublicaciones (portadas):', error);
          this.isLoading = false;
          this.utilitarioService.loading = false;
          this.fResultados = false;
          this.fResultados1 = true;
        }
      },
    });
  }
  filterRange(arr, a, b) {
    if (arr != null && a != null && b != null) {
      return arr.filter((item) => a <= item && item <= b);
    } else {
      return false;
    }
  }

  cambiarPagina(pagina: number) {
    // console.log('pagina', pagina);

    // Normalizar límites
    if (pagina < 1) pagina = 1;
    if (this.totalPaginas && pagina > this.totalPaginas)
      pagina = this.totalPaginas;

    // Si ya estamos en esa página, no hacer nada
    if (pagina === this.paginaActual) {
      // console.log('Ya estás en la página', pagina);
      return;
    }

    // Activar loading solo si vamos a cambiar de página
    this.utilitarioService.loading = true;

    // NO modificar paginaActual aquí - dejar que queryParams.subscribe lo haga
    // para mantener la sincronización con la URL

    // 🔗 Sincroniza con la URL - queryParams.subscribe actualizará paginaActual y ejecutará la búsqueda
    this.syncPageToUrl(pagina);
    // NO ejecutar búsquedas aquí - dejar que queryParams.subscribe lo maneje
  }

  actualizarRangosPaginacion() {
    const pagina = this.paginaActual;
    const isMobile = window.innerWidth <= 991;

    if (isMobile) {
      // Mostrar solo 3 números de página en mobile (página actual ± 1)
      const halfRange = 1;
      this.rangoInicio = Math.max(0, pagina - halfRange);
      this.rangoFin = Math.min(this.totalPaginas - 1, pagina + halfRange);

      // Asegurar que siempre se muestren 3 páginas si hay suficientes
      if (this.rangoFin - this.rangoInicio < 2 && this.totalPaginas >= 3) {
        if (pagina === 0) {
          this.rangoFin = Math.min(2, this.totalPaginas - 1);
        } else if (pagina === this.totalPaginas - 1) {
          this.rangoInicio = Math.max(0, this.totalPaginas - 3);
        }
      }
    } else {
      // Lógica original para desktop (5 números)
      this.rangoInicio = pagina - 3;
      this.rangoFin = pagina + 1;

      if (pagina == 0 || pagina == 1) {
        this.rangoInicio = 0;
        this.rangoFin = 4;
      }

      if (pagina >= this.totalPaginas) {
        this.rangoInicio = pagina - 5;
        this.rangoFin = pagina;
      }

      if (pagina == 2) {
        this.rangoInicio = 0;
        this.rangoFin = pagina + 2;
      }
    }
  }

  active(pagina) {
    return this.paginaActual == pagina ? 'active' : '';
  }

  /**
   * Busca todas las publicaciones realizadas
   * Pueden ser fotografias, portadas históricas y hemeroteca digital
   */
  busquedaGeneral() {
    const myId = ++this.requestId;

    // Limpiar datos inmediatamente al iniciar búsqueda general
    this.isLoading = true;
    this.fResultados = false;
    this.fResultados1 = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    // console.log('busquedaGeneral');
    this.generalsearchrequest = new Generalsearchrequest();
    //console.log(this.txtBusqueda);
    this.filtroBusquedaGeneral = this.utilitarioService.busqueda;

    this.generalsearchrequest.busquedaGeneral = this.utilitarioService.busqueda;
    this.tagChoosen = '';
    this.generalsearchrequest.fecIni = this.utilitarioService.fecIni;
    this.generalsearchrequest.fecFin = this.utilitarioService.fecFin;
    this.generalsearchrequest.categoria = 'PORTADAS_HISTORICAS';
    this.generalsearchrequest.page = this.paginaActual.toString();
    this.generalsearchrequest.size = '12';
    this.utilitarioService.loading = true;

    // console.log('generalsearchrequest', this.generalsearchrequest);
    this.novedadesService
      .buscarCatalogoGeneral(this.generalsearchrequest)
      .subscribe({
        next: (data) => {
          // console.log('data', data);
          if (myId !== this.requestId) return;
          if (data.response.codeResponse == '0000') {
            this.busquedasGeneral = true;
            this.busquedaPublicaciones = false;
            this.busquedaMerchadising = false;
            this.listProductos = data;
            this.totalPaginas = Number(
              this.listProductos.response.nroTotalPaginas
            );
            this.totalPaginasArray = Array.from(
              Array(Number(this.listProductos.response.nroTotalPaginas)).keys()
            );
            this.subBusqueda = '';
            // Actualizar rangos de paginación ahora que conocemos el total de páginas
            this.actualizarRangosPaginacion();

            this.totalPaginasArrayTemp = this.filterRange(
              this.totalPaginasArray,
              this.rangoInicio,
              this.rangoFin
            );
            this.fMerchadising = false;
            // this.novedadesService.idCategoria="";
            // this.novedadesService.idSubCategoria="";
            // this.utilitarioService.busqueda="";
            this.fResultados = true;
            this.fResultados1 = false;
            this.isLoading = false;
            this.utilitarioService.loading = false;

            this.listProductos.response.list.forEach((fila, index) => {
              const columnaIndex = index % 3; // Determina en qué columna irá el elemento
              this.columnas[columnaIndex].push(fila);
            });
            this.listProductos.response.list.forEach((fila, index) => {
              const columnaIndex = index % 2; // Determina en qué columna irá el elemento
              this.columnas1[columnaIndex].push(fila);
            });
          } else {
            this.fResultados = false;
            this.fResultados1 = true;
            this.isLoading = false;
            this.utilitarioService.loading = false;
            this.novedadesService.idCategoria = '';
            this.novedadesService.idSubCategoria = '';
            this.utilitarioService.busqueda = '';
          }
        },
        error: (error) => {
          if (error.status === 429) {
            // Extraer información detallada del error
            const errorBody = error.error;
            const retrySeconds = errorBody?.retryAfterSeconds || 8;
            const esHome =
              this.router.url === '/' || this.router.url === '/inicio';

            // console.log('⏱️ Rate limit detectado en header:', {
              // retryAfterSeconds: retrySeconds,
              // ip: errorBody?.ip,
              // path: errorBody?.path,
              // penaltyLevel: errorBody?.penaltyLevel,
              // esHome: esHome,
            // });
            this.isLoading = false;
            this.utilitarioService.loading = false;
            // Activar el rate limiting usando el servicio centralizado
            this.rateLimitService.activateRateLimit(retrySeconds, esHome);
          } else {
            console.error('❌ Error en busquedaGeneral (portadas):', error);

            this.fResultados = false;
            this.fResultados1 = true;
          }
        },
      });
  }

  busquedaGeneralXTag() {
    // Limpiar datos inmediatamente al iniciar búsqueda general por tag
    this.isLoading = true;
    this.fResultados = false;
    this.fResultados1 = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    // console.log('busquedaGeneralXTag');
    this.tagChoosen = this.utilitarioService.busqueda;
    this.generalsearchrequest = new Generalsearchrequest();
    this.filtroBusquedaGeneral = this.utilitarioService.busqueda;

    this.generalsearchrequest.busquedaGeneral = this.utilitarioService.busqueda;
    this.generalsearchrequest.categoria = 'PORTADAS_HISTORICAS';
    this.generalsearchrequest.page = this.paginaActual.toString();
    this.generalsearchrequest.size = '12';
    this.utilitarioService.loading = true;

    // console.log('generalsearchrequest', this.generalsearchrequest);
    this.novedadesService
      .buscarCatalogoGeneral2(this.generalsearchrequest)
      .subscribe((data) => {
        // console.log('data', data);
        if (data.response.codeResponse == '0000') {
          this.busquedasGeneral = true;
          this.busquedaPublicaciones = false;
          this.busquedaMerchadising = false;
          this.listProductos = data;
          this.totalPaginas = Number(
            this.listProductos.response.nroTotalPaginas
          );
          this.totalPaginasArray = Array.from(
            Array(Number(this.listProductos.response.nroTotalPaginas)).keys()
          );
          this.subBusqueda = '';
          // Actualizar rangos de paginación ahora que conocemos el total de páginas
          this.actualizarRangosPaginacion();

          this.totalPaginasArrayTemp = this.filterRange(
            this.totalPaginasArray,
            this.rangoInicio,
            this.rangoFin
          );
          this.fMerchadising = false;
          // this.novedadesService.idCategoria="";
          // this.novedadesService.idSubCategoria="";
          // this.utilitarioService.busqueda="";
          this.utilitarioService.tipobusqueda = '';
          this.fResultados = true;
          this.fResultados1 = false;
          this.isLoading = false;
          this.utilitarioService.loading = false;

          // Cargar tokens para las imágenes de la página actual
          this.loadTokensForCurrentPage();

          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 3; // Determina en qué columna irá el elemento
            this.columnas[columnaIndex].push(fila);
            // Cargar imagen protegida para cada elemento
            this.loadProtectedThumbnail(fila.activoId);
          });
          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 2; // Determina en qué columna irá el elemento
            this.columnas1[columnaIndex].push(fila);
          });

          // Configurar columnas según dispositivo
          if (this.isIPad()) {
            this.columnas2 = this.columnas1;
            this.showIpad = true;
          } else {
            this.columnas2 = this.columnas;
            this.showIpad = false;
          }
        } else {
          this.fResultados = false;
          this.fResultados1 = true;
          this.isLoading = false;
          this.utilitarioService.loading = false;
          this.novedadesService.idCategoria = '';
          this.novedadesService.idSubCategoria = '';
          this.utilitarioService.busqueda = '';
          this.utilitarioService.tipobusqueda = '';
        }
        this.utilitarioService.loading = false;
      });
  }

  busquedaGeneralPaginacion() {
    // console.log('busquedaGeneralPaginacion');
    this.generalsearchrequest = new Generalsearchrequest();
    this.generalsearchrequest.busquedaGeneral = this.filtroBusquedaGeneral;
    this.generalsearchrequest.fecIni = this.utilitarioService.fecIni;
    this.generalsearchrequest.fecFin = this.utilitarioService.fecFin;
    this.generalsearchrequest.categoria = 'PORTADAS_HISTORICAS';
    this.generalsearchrequest.page = this.paginaActual.toString();
    this.generalsearchrequest.size = '12';
    this.utilitarioService.loading = true;

    // console.log('generalsearchrequest', this.generalsearchrequest);
    this.novedadesService
      .buscarCatalogoGeneral(this.generalsearchrequest)
      .subscribe((data) => {
        // console.log('data', data);
        if (data.response.codeResponse == '0000') {
          this.busquedasGeneral = true;
          this.busquedaPublicaciones = false;
          this.busquedaMerchadising = false;
          this.listProductos = data;
          this.totalPaginas = Number(
            this.listProductos.response.nroTotalPaginas
          );
          this.totalPaginasArray = Array.from(
            Array(Number(this.listProductos.response.nroTotalPaginas)).keys()
          );
          this.subBusqueda = '';
          // Actualizar rangos de paginación ahora que conocemos el total de páginas
          this.actualizarRangosPaginacion();

          this.totalPaginasArrayTemp = this.filterRange(
            this.totalPaginasArray,
            this.rangoInicio,
            this.rangoFin
          );
          this.fMerchadising = false;
          this.novedadesService.idSubCategoria = '';
          this.utilitarioService.busqueda = '';
          this.fResultados = true;
          this.fResultados1 = false;
          this.isLoading = false;
          this.utilitarioService.loading = false;

          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 3; // Determina en qué columna irá el elemento
            this.columnas[columnaIndex].push(fila);
          });
          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 2; // Determina en qué columna irá el elemento
            this.columnas1[columnaIndex].push(fila);
          });
        } else {
          this.fResultados = false;
          this.fResultados1 = true;
          this.isLoading = false;
          this.utilitarioService.loading = false;
          this.novedadesService.idSubCategoria = '';
          this.utilitarioService.busqueda = '';
        }
        this.utilitarioService.loading = false;
      });
  }

  busquedaGeneralPaginacion2() {
    // console.log('busquedaGeneralPaginacion2');
    this.generalsearchrequest = new Generalsearchrequest();
    this.generalsearchrequest.busquedaGeneral = this.filtroBusquedaGeneral;
    this.generalsearchrequest.categoria = 'PORTADAS_HISTORICAS';
    this.generalsearchrequest.page = this.paginaActual.toString();
    this.generalsearchrequest.size = '12';
    this.utilitarioService.loading = true;

    // console.log('generalsearchrequest', this.generalsearchrequest);
    this.novedadesService
      .buscarCatalogoGeneral2(this.generalsearchrequest)
      .subscribe((data) => {
        // console.log('data', data);
        if (data.response.codeResponse == '0000') {
          this.busquedasGeneral = true;
          this.busquedaPublicaciones = false;
          this.busquedaMerchadising = false;
          this.listProductos = data;
          this.totalPaginas = Number(
            this.listProductos.response.nroTotalPaginas
          );
          this.totalPaginasArray = Array.from(
            Array(Number(this.listProductos.response.nroTotalPaginas)).keys()
          );
          this.subBusqueda = '';
          // Actualizar rangos de paginación ahora que conocemos el total de páginas
          this.actualizarRangosPaginacion();

          this.totalPaginasArrayTemp = this.filterRange(
            this.totalPaginasArray,
            this.rangoInicio,
            this.rangoFin
          );
          this.fMerchadising = false;
          //this.novedadesService.idCategoria=""; //daet1
          this.novedadesService.idSubCategoria = '';
          this.utilitarioService.busqueda = '';
          this.fResultados = true;
          this.fResultados1 = false;
          this.isLoading = false;
          this.utilitarioService.loading = false;

          // Cargar tokens para las imágenes de la página actual
          this.loadTokensForCurrentPage();

          // Organizar en columnas y cargar imágenes
          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 3;
            this.columnas[columnaIndex].push(fila);
            this.loadProtectedThumbnail(fila.activoId);
          });

          this.listProductos.response.list.forEach((fila, index) => {
            const columnaIndex = index % 2;
            this.columnas1[columnaIndex].push(fila);
          });

          // Configurar columnas según dispositivo
          if (this.isIPad()) {
            this.columnas2 = this.columnas1;
            this.showIpad = true;
          } else {
            this.columnas2 = this.columnas;
            this.showIpad = false;
          }
        } else {
          this.fResultados = false;
          this.fResultados1 = true;
          this.isLoading = false;
          this.utilitarioService.loading = false;
          //this.novedadesService.idCategoria="";//daet1
          this.novedadesService.idSubCategoria = '';
          this.utilitarioService.busqueda = '';
        }
        this.utilitarioService.loading = false;
      });
  }

  private syncCatFromPath(): void {
    const timestamp = new Date().toLocaleTimeString('es-PE', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    const tree = this.router.parseUrl(this.router.url);
    const segs =
      tree.root.children['primary']?.segments.map((s) => s.path) || [];

    const catSlug = segs[0]; // 'fotografias' | 'portadas' | 'consultas'
    const subSlug = segs[1] || ''; // 'politica' | 'siglo-xx' | ...

    const idCat = this.CAT_SLUG_TO_ID[catSlug] || '2';
    const idSub = this.SUB_SLUG_TO_ID[idCat]?.[subSlug] || '';

    //console.log(`🔍 [PORTADAS] [${timestamp}] syncCatFromPath ANTES: idCategoria=${this.novedadesService.idCategoria}, idSubCategoria=${this.novedadesService.idSubCategoria}`);

    this.novedadesService.idCategoria = idCat;
    this.novedadesService.idSubCategoria = idSub;
    this.utilitarioService.idCategoria = idCat;

    //console.log(`✅ [PORTADAS] [${timestamp}] syncCatFromPath DESPUES: idCategoria=${idCat}, idSubCategoria=${idSub}, URL=${this.router.url}`);

    // 🔄 Sincronizar con el header para que marque la subcategoría correcta
    this.syncHeaderSelection(idCat, idSub);
  }

  /**
   * Sincroniza la selección del header con la categoría y subcategoría actual
   */
  private syncHeaderSelection(
    idCategoria: string,
    idSubCategoria?: string
  ): void {
    const timestamp = new Date().toLocaleTimeString('es-PE', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    // 🚫 NO sincronizar si estamos en una ruta de detalle (el detalle lo hará)
    const currentUrl = this.router.url;
    if (currentUrl.includes('/dt/') || currentUrl.includes('/dtp/')) {
      //console.log(`⏭️ [PORTADAS] [${timestamp}] Omitiendo sincronización - estamos en ruta de detalle:`, currentUrl);
      return;
    }

    // console.log(
      // `🔄 [PORTADAS] [${timestamp}] Sincronizando header con categoría: ${idCategoria}, subcategoría: ${idSubCategoria}`
    // );

    // Actualizar utilitarioService para que el header lo detecte
    this.utilitarioService.idCategoria = idCategoria;
    this.utilitarioService.idSubCategoria = idSubCategoria || '';

    setTimeout(() => {
      const headerElement = document.querySelector('app-header');
      if (headerElement) {
        // Intentar acceder al componente a través de diferentes índices del contexto de Angular
        const ngContext = (headerElement as any).__ngContext__;
        if (ngContext) {
          // Angular almacena el componente en diferentes posiciones según la versión
          let headerComponent = null;
          for (let i = 0; i < ngContext.length; i++) {
            if (
              ngContext[i] &&
              typeof ngContext[i].setActiveHeaderCategory === 'function'
            ) {
              headerComponent = ngContext[i];
              break;
            }
          }

          if (headerComponent) {
            headerComponent.setActiveHeaderCategory(
              idCategoria,
              idSubCategoria
            );
            //console.log(`✅ [PORTADAS] [${timestamp}] Header sincronizado exitosamente`);
          } else {
            //console.warn(`⚠️ [PORTADAS] [${timestamp}] No se encontró el método setActiveHeaderCategory en el header`);
            //console.log('Contexto disponible:', ngContext);
          }
        } else {
          //console.warn(`⚠️ [PORTADAS] [${timestamp}] No se encontró el contexto de Angular`);
        }
      } else {
        //console.warn(`⚠️ [PORTADAS] [${timestamp}] No se encontró el elemento app-header`);
      }
    }, 150);
  }

  // Método para generar URL amigable basada en IDs
  private buildFriendlyUrl(
    idCategoria: string,
    idSubCategoria?: string
  ): string[] {
    const catSlug = this.CAT_ID_TO_SLUG[idCategoria] || 'portadas';
    const urlSegments = [catSlug];

    if (idSubCategoria && this.SUB_ID_TO_SLUG[idCategoria]?.[idSubCategoria]) {
      const subSlug = this.SUB_ID_TO_SLUG[idCategoria][idSubCategoria];
      urlSegments.push(subSlug);
    }

    // console.log('🔗 Construyendo URL amigable:', {
      // idCategoria,
      // idSubCategoria,
      // urlSegments,
    // });
    return urlSegments;
  }

  // Método para navegar a una subcategoría usando URL amigable
  private navigateToSubcategory(idSubCategoria: string): void {
    const idCategoria = this.novedadesService.idCategoria || '2';
    const friendlyUrl = this.buildFriendlyUrl(idCategoria, idSubCategoria);

    // console.log('🔗 Navegando a subcategoría:', {
      // idCategoria,
      // idSubCategoria,
      // friendlyUrl,
    // });
    this.router.navigate(['/', ...friendlyUrl], {
      queryParamsHandling: 'preserve', // Mantener filtros actuales
    });
  }

  ngOnInit(): void {
    const timestamp = new Date().toLocaleTimeString('es-PE', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    // console.log(`🔵 [PORTADAS] [${timestamp}] ngOnInit - Iniciando componente`);

    // Suscribirse al estado del rate limit
    this.rateLimitSubscription = this.rateLimitService.rateLimitState$.subscribe(
      state => {
        this.rateLimitActive = state.isActive && state.timeRemaining > 0;
      }
    );

    this.prevSeo = this.seo.snapshot();

    // SEO para Portadas: "Portadas | Archivo Histórico | Diario Oficial El Peruano"
    this.seo.setMeta({
      title: 'Portadas | Archivo Histórico',
      suffix: 'Diario Oficial El Peruano',
      description:
        'Explore portadas históricas del Diario Oficial El Peruano desde el siglo XIX hasta la actualidad',
      og: true,
    });
    this.seo.setCanonicalFromCurrentUrl();

    let isFirstLoad = true; // Flag para evitar doble carga en inicio

    // 0) sincroniza cat/sub desde el PATH actual
    this.syncCatFromPath();

    // ✅ VALIDACIÓN: Solo continuar si estamos en ruta de portadas (idCategoria = '2')
    if (this.novedadesService.idCategoria !== '2') {
      // console.log(
        // `⏭️ [PORTADAS] [${timestamp}] Componente ignorado - no estamos en portadas. idCategoria: ${this.novedadesService.idCategoria}`
      // );
      return;
    }

    // 1) Escuchar cambios en query params (igual que fotografías)
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const q = params['q'] ?? '';
        const fi = params['fi'] ?? '';
        const ff = params['ff'] ?? '';
        const pageFromUrl = parseInt(params['page'] || '1', 10);

        // console.log('🔄 [PORTADAS] QueryParams detectados:', {
          // page: pageFromUrl,
          // q,
          // fi,
          // ff,
        // });
        // console.log('🔄 [PORTADAS] Página actual antes:', this.paginaActual);

        this.paginaActual = isNaN(pageFromUrl) ? 1 : pageFromUrl;
        this.utilitarioService.busqueda = q;
        this.utilitarioService.fecIni = fi;
        this.utilitarioService.fecFin = ff;

        this.lblFecIni = this.ymdToDmy(fi);
        this.lblFecFin = this.ymdToDmy(ff);

        // console.log('🔄 [PORTADAS] Nueva página:', this.paginaActual);

        if (this.utilitarioService.tipobusqueda === 'tag') {
          this.obtenerCategoriasBasico2();
        } else if (q.length > 0 || (fi && ff)) {
          this.obtenerCategoriasBasico();
        } else {
          this.obtenerCategorias();
        }

        isFirstLoad = false; // Marcar que ya se ejecutó la primera carga
      });

    // 2) si cambia el PATH (p.ej. /portadas/siglo-xx → /portadas/siglo-xxi)
    this.router.events
      .pipe(
        filter((ev) => ev instanceof NavigationEnd),
        // Mapear al URL completo como clave única
        map((ev: NavigationEnd) => ev.urlAfterRedirects || ev.url),
        // Solo continuar si el URL cambió (evita duplicados)
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((url) => {
        const timestamp = new Date().toLocaleTimeString('es-PE', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });

        // Si es la primera carga, no hacer nada (ya se manejó en queryParams)
        if (isFirstLoad) {
          // console.log(
            // `⏭️ [PORTADAS] [${timestamp}] NavigationEnd ignorado - primera carga`
          // );
          return;
        }

        // console.log(
          // `🔄 [PORTADAS] [${timestamp}] NavigationEnd detectado - URL: ${url}`
        // );

        // Limpiar cache al detectar navegación
        this.clearProtectedImagesCache();

        this.syncCatFromPath();

        // si NO hay filtros en query, recarga por categoría/sub
        const hasFilters =
          this.utilitarioService.busqueda?.length > 0 ||
          (!!this.utilitarioService.fecIni && !!this.utilitarioService.fecFin);
        if (!hasFilters) {
          // Solo resetear página a 1 si no hay parámetro page en la URL
          const currentUrl = this.router.url;
          if (!currentUrl.includes('page=')) {
            this.paginaActual = 1;
          }
          //console.log(`🔄 [PORTADAS] [${timestamp}] NavigationEnd - Llamando obtenerCategorias (Página: ${this.paginaActual})`);
          this.obtenerCategorias();
        }
      });

    this.updateMargin();
  }

  private ymdToDmy(s: string): string {
    if (!s) return '';
    const [y, m, d] = s.split('-');
    return `${d}/${m}/${y}`;
  }

  /*
  ngAfterViewInit(): void {
    // console.log("ngAfterViewInit");
    this.updateMargin();
  }*/

  // nlpr ini
  fixedContainerHeight: number = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.updateMargin(); // Update height
    //this.buscarPublicaciones();
  }
  private updateMargin(): void {
    setTimeout(() => {
      const fixedContainer = document.querySelector(
        '.fixed-submenus'
      ) as HTMLElement;
      if (fixedContainer) {
        this.fixedContainerHeight = fixedContainer.offsetHeight;
        // console.log('tamaniooooooooooooooooo' + this.fixedContainerHeight);
        const contentContainer = this.el.nativeElement.querySelector(
          '.consultaContainer'
        ) as HTMLElement;
        if (contentContainer) {
          // console.log('cambio web');
          this.renderer.setStyle(
            contentContainer,
            'margin-top',
            `${this.fixedContainerHeight}px`
          );
        }
        const contentContainerM = this.el.nativeElement.querySelector(
          '.consultaContainerM'
        ) as HTMLElement;
        if (contentContainerM) {
          // console.log('cambio movil');
          this.renderer.setStyle(
            contentContainerM,
            'margin-top',
            `${this.fixedContainerHeight}px`
          );
        }
      }
    }, 0); // Retrasar la ejecución hasta el siguiente ciclo de eventos
  }
  // nlpr fin

  private syncPageToUrl(pagina: number) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: pagina },
      queryParamsHandling: 'merge',
    });
  }

  getColumnClass(): string {
    return window.innerWidth > 800 ? 'columnas' : 'columnas1';
  }

  isIPad(): boolean {
    // console.log('xxxxx:' + navigator.userAgent);
    // console.log('xxxxxx:' + navigator.userAgent.match(/iPad/i));
    const iPadT = navigator.userAgent.match(/iPad/i);
    const iPadString = iPadT ? iPadT[0] : '';
    // console.log('xxxiPadString' + iPadString);

    const userAgent = navigator.userAgent;
    if (iPadString === 'iPad') return true;
    else return false; //return /iPad/i.test(userAgent);
  }

  loadProtectedThumbnail(imageId: string): void {
    if (!imageId) {
      return;
    }

    // Evitar múltiples peticiones para la misma imagen
    if (this.protectedImages.has(imageId)) {
      //console.log('⚠️ [PORTADAS] Intento de carga duplicada bloqueado:', imageId);
      return; // Ya está siendo procesada o ya existe
    }

    //console.log('🔄 [PORTADAS] Iniciando carga de imagen:', imageId);

    // Marcar como en proceso para evitar duplicados
    this.protectedImages.set(imageId, {
      imageId: imageId,
      protectedThumbnailUrl: null,
      expiresIn: 0,
      loadedAt: Date.now(),
    });

    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now();
        this.protectedImages.set(imageId, response);
        // Actualizar cache de URL
        this.imageUrlCache.set(imageId, response.protectedThumbnailUrl);

        // Cachear dimensiones en el servicio para que persistan entre navegaciones
        if (
          response.metadata &&
          response.metadata.width &&
          response.metadata.height
        ) {
          this.novedadesService.imageDimensionsCache.set(imageId, {
            width: response.metadata.width,
            height: response.metadata.height
          });
        }

        // Calcular tiempo transcurrido desde que inició la carga
        const startTime = this.imageLoadStartTimes.get(imageId) || Date.now();
        const elapsedTime = Date.now() - startTime;
        const minimumDelay = 800; // 800ms mínimo para apreciar el skeleton

        // Siempre esperar el tiempo mínimo completo
        const timeToWait = Math.max(0, minimumDelay - elapsedTime);

        setTimeout(() => {
          this.isSkeletonVisible.set(imageId, false);
          this.imageReadyForDisplay.set(imageId, true);
          this.cdr.detectChanges(); // Forzar detección de cambios
        }, timeToWait);

        //console.log('✅ Token recibido para panel de portadas:', imageId);
      },
      error: (error) => {
        if (error.status === 429) {
          // Extraer información detallada del error
          const errorBody = error.error;
          const retrySeconds = errorBody?.retryAfterSeconds || 8;
          const esHome =
            this.router.url === '/' || this.router.url === '/inicio';

          // console.log('⏱️ Rate limit detectado en header:', {
            // retryAfterSeconds: retrySeconds,
            // ip: errorBody?.ip,
            // path: errorBody?.path,
            // penaltyLevel: errorBody?.penaltyLevel,
            // esHome: esHome,
          // });
          this.isLoading = false;
          this.utilitarioService.loading = false;
          // Activar el rate limiting usando el servicio centralizado
          this.rateLimitService.activateRateLimit(retrySeconds, esHome);
        } else {
          console.error(
            '❌ Error cargando imagen del panel de portadas:',
            imageId,
            error
          );
          this.isLoading = false;
          this.utilitarioService.loading = false;
        }

        // Remover de la lista en caso de error para permitir reintento
        this.protectedImages.delete(imageId);
        this.imageLoadStartTimes.delete(imageId);
        this.isSkeletonVisible.delete(imageId);
      },
    });
  }

  // Cargar tokens de forma inteligente para elementos visibles
  loadTokensForCurrentPage(): void {
    if (!this.listProductos?.response?.list) return;

    const currentPageItems = this.listProductos.response.list;
    // console.log(
      // 'Cargando tokens para',
      // currentPageItems.length,
      // 'portadas del panel actual'
    // );

    currentPageItems.forEach((item) => {
      if (item.activoId) {
        this.loadProtectedThumbnail(item.activoId);
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    if (!imageId) {
      return null;
    }

    // Si el skeleton está visible, no mostrar imagen aún
    if (this.isSkeletonVisible.get(imageId)) {
      return null;
    }

    // Si ya no está el skeleton, devolver la URL desde el cache
    return this.imageUrlCache.get(imageId) || null;
  }

  // Método público para el template
  shouldShowSkeleton(imageId: string): boolean {
    if (!imageId) return false;

    // Si nunca se ha iniciado la carga, solo marcar como visible
    // La carga ya se hace en buscarPublicaciones()
    if (!this.imageLoadStartTimes.has(imageId)) {
      this.imageLoadStartTimes.set(imageId, Date.now());
      this.isSkeletonVisible.set(imageId, true);
      return true;
    }

    return this.isSkeletonVisible.get(imageId) || false;
  }

  clearProtectedImagesCache(): void {
    this.protectedImages.clear();
    this.imageUrlCache.clear();
    this.imageLoadStartTimes.clear();
    this.imageReadyForDisplay.clear();
    this.isSkeletonVisible.clear();
  }

  // Manejo de filtros del sidebar
  onFiltersChanged(filters: any): void {
    // console.log('Filtros aplicados en portadas:', filters);

    // Resetear página a 1 cuando se aplican filtros
    this.paginaActual = 1;

    // Aplicar filtros y buscar
    this.applyFiltersAndSearch(filters);
  }

  private applyFiltersAndSearch(filters: any): void {
    // Limpiar datos y activar loading
    this.isLoading = true;
    this.fResultados = false;
    this.fResultados1 = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    // Configurar request basado en los filtros
    const catalogoRequest = new CatalogoRequest();
    catalogoRequest.authorId = '0';
    catalogoRequest.categoryId = '0';
    catalogoRequest.categoryName = filters.contentType || 'PORTADAS_HISTORICAS';
    catalogoRequest.page = this.paginaActual.toString();
    catalogoRequest.subCategoryId = '0';
    catalogoRequest.subCategoryName = filters.subCategory || '';
    catalogoRequest.publicationId = '0';
    catalogoRequest.size = '12';
    catalogoRequest.title = filters.searchText || '';
    catalogoRequest.yearId = '0';

    // console.log('Request de filtrado:', catalogoRequest);

    // Ejecutar búsqueda
    this.novedadesService.buscarCatalogo(catalogoRequest).subscribe((data) => {
      if (data.response.codeResponse === '0000') {
        this.listProductos = data;
        this.totalPaginas = Number(this.listProductos.response.nroTotalPaginas);
        this.totalPaginasArray = Array.from(
          Array(Number(this.listProductos.response.nroTotalPaginas)).keys()
        );

        this.busquedasGeneral = false;
        this.busquedaPublicaciones = true;
        this.busquedaMerchadising = false;

        // Actualizar rangos de paginación ahora que conocemos el total de páginas
        this.actualizarRangosPaginacion();

        this.totalPaginasArrayTemp = this.filterRange(
          this.totalPaginasArray,
          this.rangoInicio,
          this.rangoFin
        );

        this.fResultados = true;
        this.fResultados1 = false;
        this.isLoading = false;
        this.utilitarioService.loading = false;

        // Cargar tokens para las imágenes de la página actual
        this.loadTokensForCurrentPage();

        // Organizar en columnas y cargar imágenes
        this.listProductos.response.list.forEach((fila, index) => {
          const columnaIndex = index % 3;
          this.columnas[columnaIndex].push(fila);
          this.loadProtectedThumbnail(fila.activoId);
        });

        this.listProductos.response.list.forEach((fila, index) => {
          const columnaIndex = index % 2;
          this.columnas1[columnaIndex].push(fila);
        });

        // Configurar columnas según dispositivo
        if (this.isIPad()) {
          this.columnas2 = this.columnas1;
          this.showIpad = true;
        } else {
          this.columnas2 = this.columnas;
          this.showIpad = false;
        }
      } else {
        this.fResultados = false;
        this.fResultados1 = true;
        this.isLoading = false;
        this.utilitarioService.loading = false;
      }
    });
  }

  // Manejo de ordenamiento
  onSortChange(sortValue: string): void {
    // console.log('Ordenamiento aplicado:', sortValue);

    // Guardar el ordenamiento actual
    this.currentSortValue = sortValue;

    // Resetear página a 1 cuando se aplica ordenamiento
    this.paginaActual = 1;

    // Aplicar ordenamiento a los resultados actuales
    this.applySortToResults(sortValue);
  }

  private applySortToResults(sortValue: string): void {
    if (
      !this.listProductos?.response?.list ||
      this.listProductos.response.list.length <= 0
    ) {
      return;
    }

    let sortedList = [...this.listProductos.response.list];

    switch (sortValue) {
      case 'alfabetico_asc':
        sortedList.sort((a: any, b: any) => a.title.localeCompare(b.title));
        break;
      case 'alfabetico_desc':
        sortedList.sort((a: any, b: any) => b.title.localeCompare(a.title));
        break;
      case 'fecha_asc':
        sortedList.sort((a: any, b: any) => {
          const dateA = new Date(a.fechaPublicacion || a.yearName || '1900');
          const dateB = new Date(b.fechaPublicacion || b.yearName || '1900');
          return dateA.getTime() - dateB.getTime();
        });
        break;
      case 'fecha_desc':
        sortedList.sort((a: any, b: any) => {
          const dateA = new Date(a.fechaPublicacion || a.yearName || '1900');
          const dateB = new Date(b.fechaPublicacion || b.yearName || '1900');
          return dateB.getTime() - dateA.getTime();
        });
        break;
      default:
        // Sin ordenamiento específico
        break;
    }

    // Actualizar la lista con los resultados ordenados
    (this.listProductos.response.list as any) = sortedList;

    // Limpiar cache de imágenes y recargar tokens para el nuevo orden
    this.clearProtectedImagesCache();

    // Reorganizar en columnas para la vista de galería
    this.organizarEnColumnas();

    // Cargar imagen protegida solo para las primeras 12 imágenes (evitar sobrecarga)
    const limitedList = sortedList.slice(0, 12);
    limitedList.forEach((item) => {
      if (item.activoId) {
        this.loadProtectedThumbnail(item.activoId);
      }
    });
  }

  private organizarEnColumnas(): void {
    // Limpiar columnas
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];

    // Redistribuir elementos en columnas
    if (this.listProductos?.response?.list) {
      this.listProductos.response.list.forEach((item, index) => {
        this.columnas[index % 3].push(item);
        this.columnas1[index % 2].push(item);
        this.columnas2.push(item);
      });
    }
  }

  // Método para calcular dimensiones del skeleton basado en orientación
  // DEPRECADO: Ahora usamos aspect-ratio responsivo
  getSkeletonDimensions(item: any): { width: string; height: string } {
    // Retornar valores responsivos en lugar de píxeles fijos
    return { width: '100%', height: '100%' };
  }

  // Nuevo método para obtener el aspect-ratio basado en las dimensiones reales
  getSkeletonAspectRatio(item: any): string {
    const dimensions = this.getRealDimensions(item);
    const width = dimensions.width;
    const height = dimensions.height;

    // Retornar el aspect-ratio en formato CSS
    return `${width} / ${height}`;
  }

  // Método para obtener dimensiones reales desde datos del item
  getRealDimensions(item: any): { width: number; height: number } {
    if (!item) {
      return { width: 3, height: 4 }; // Default portrait para portadas
    }

    // 1. Intentar metadatos del componente (protectedImages local)
    const protectedImage = this.protectedImages.get(item.activoId);
    if (
      protectedImage &&
      protectedImage.metadata &&
      protectedImage.metadata.width &&
      protectedImage.metadata.height
    ) {
      return {
        width: protectedImage.metadata.width,
        height: protectedImage.metadata.height,
      };
    }

    // 2. Intentar cache persistente del servicio (sobrevive a la navegación)
    const cached = this.novedadesService.imageDimensionsCache.get(item.activoId);
    if (cached) {
      return cached;
    }

    // 3. Fallback a las dimensiones que vienen en los datos del item
    return {
      width: +item.width || 3,
      height: +item.height || 4,
    };
  }

  // Método para forzar reset completo y asegurar independencia entre componentes
  private forceCompleteReset(): void {
    //console.log('🔄 [PORTADAS] Forzando reset completo del componente');

    // Resetear todas las variables de estado
    this.fResultados = false;
    this.fResultados1 = false;
    this.isLoading = false;
    this.paginaActual = 1;

    // Limpiar arrays de datos
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];

    // Resetear variables de búsqueda
    this.lblTextoBusqueda = '';
    this.lblFecIni = '';
    this.lblFecFin = '';
    this.tagChoosen = '';

    // Incrementar requestId para invalidar requests pendientes
    this.requestId = Date.now();

    //console.log('✅ [PORTADAS] Reset completo finalizado');
  }

  /**
   * Limpia todos los filtros de búsqueda y permanece en la categoría actual
   */
  limpiarFiltros(): void {
    // Obtener la categoría actual desde la URL
    const currentUrl = this.router.url;
    let baseRoute = '/portadas';

    if (currentUrl.includes('/fotografias')) {
      baseRoute = '/fotografias';
    } else if (currentUrl.includes('/consultas')) {
      baseRoute = '/consultas';
    }

    // Navegar a la ruta base sin query params
    this.router.navigate([baseRoute]);
  }

  /**
   * Vuelve a la página principal (home)
   */
  volverInicio(): void {
    this.router.navigate(['/']);
  }

  ngOnDestroy(): void {
    // Completar todas las suscripciones
    this.destroy$.next();
    this.destroy$.complete();

    // Limpiar suscripción del rate limit
    if (this.rateLimitSubscription) {
      this.rateLimitSubscription.unsubscribe();
    }

    // Limpiar completamente todo el cache al destruir el componente
    this.clearProtectedImagesCache();
  }

  // Efecto 3D que sigue al mouse
  onMouseMove(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    const imagen = card.querySelector('.imagen-3d') as HTMLElement;

    if (!imagen) return;

    const rect = card.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * -10; // -10 a 10 grados
    const rotateY = ((x - centerX) / centerX) * 10; // -10 a 10 grados

    // Calcular posición del brillo basada en el mouse (0 a 100%)
    const posX = (x / rect.width) * 100;
    const posY = (y / rect.height) * 100;

    // Aplicar transformación 3D
    imagen.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`;

    // Mover el brillo siguiendo el mouse
    imagen.style.setProperty('--mouse-x', `${posX}%`);
    imagen.style.setProperty('--mouse-y', `${posY}%`);
  }

  onMouseLeave(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    const imagen = card.querySelector('.imagen-3d') as HTMLElement;

    if (!imagen) return;

    imagen.style.transform =
      'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)';

    // Resetear posición del brillo
    imagen.style.removeProperty('--mouse-x');
    imagen.style.removeProperty('--mouse-y');
  }
}
